import { getGenericFormInitialValues } from "../../../components/form/utils/initialValues";

import {
  getDrug,
  buildPrescriptionSection,
  buildInsuranceSection,
  buildDiagnosisSection,
  buildProviderSection
} from "./initialValuesUtils";

export const getPfizerSonnexusFreeDrugFormInitialValues = ({ applicationForm, formJson, treatments, diagnosis }) => {
  const initialValues = getGenericFormInitialValues(applicationForm, formJson);
  const prescriptionData = applicationForm.formData?.prescription;

  const currentDrug = getDrug(prescriptionData);

  return {
    ...initialValues,
    provider: buildProviderSection(initialValues),
    prescription: buildPrescriptionSection(initialValues, applicationForm, treatments, currentDrug),
    insurance: buildInsuranceSection(initialValues, applicationForm),
    diagnosis: buildDiagnosisSection(initialValues, diagnosis, currentDrug)
  };
};
